import AdminApp from "@/views/admin/Admin";
import Dashboard from "@/views/admin/Dashboard";
import UserValidation from "@/views/admin/UserValidation";
import AdminAccount from "@/views/admin/AdminAccount";
import CommuneAccount from "@/views/admin/CommuneAccount";
import ImportHistoric from "@/views/admin/ImportHistoric";
import { useUserStore } from "../stores/user";

const adminPrefix = "/admin";

// The admin dashboard, with sidebar
export default {
  path: adminPrefix,
  name: "Admin App",
  component: AdminApp,
  beforeEnter: (to, from, next) => {
    const userStore = useUserStore();
    if ((userStore.isAdmin || userStore.isAdminFileDownloader) !== true) {
      next("/");
      return;
    }
    next();
  },
  meta: {
    title: "Admin Dashboard",
    metaTags: [
      {
        name: "description",
        content: "Panel Admin Airbnb Taxe de Séjour.",
      },
    ],
  },
  children: [
    {
      path: "",
      name: "components.admin_title.dashboard",
      component: Dashboard,
    },
    {
      path: "user-validation",
      name: "components.admin_title.user_validation",
      component: UserValidation,
    },
    {
      path: "admin-account",
      name: "components.admin_title.admin_account",
      component: AdminAccount,
    },
    {
      path: "commune-account",
      name: "components.admin_title.commune_account",
      component: CommuneAccount,
    },
    {
      path: "imported-data",
      name: "components.admin_title.import_historic",
      component: ImportHistoric,
    },
  ],
};
